import {
  UserSubscriptionStatus,
  useWasDunningDialogDismissedSelector,
} from "@nf/common";
import { useCurrentSubscription } from "hooks";

export const useDunning = () => {
  const currentSubscription = useCurrentSubscription();

  const wasDunningDialogDismissed = useWasDunningDialogDismissedSelector();
  const isInDunning =
    currentSubscription?.Status === UserSubscriptionStatus.IN_DUNNING;

  return {
    isInDunning,
    wasDunningDialogDismissed,
  };
};
